import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { Avatar as LetterAvatar, Typography as MuiTypography, makeStyles } from '@material-ui/core';
import makeClass from 'classnames';
import { brand500Colors } from '../Theme';
var useStyles = makeStyles(function (theme) {
  var backgroundColor = brand500Colors[Math.floor(Math.random() * brand500Colors.length)];
  return {
    root: {
      display: 'flex',
      color: theme.palette.getContrastText(theme.palette.background.paper),
      '& > *': {
        margin: theme.spacing(1)
      }
    },
    rotateColor: {
      backgroundColor: backgroundColor,
      color: theme.palette.getContrastText(backgroundColor)
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3)
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7)
    }
  };
});
var typeSizeMap = {
  small: 'body2',
  default: 'h6',
  large: 'h4'
};

var Avatar = function Avatar(_ref) {
  var _objectSpread2;

  var e2e = _ref.e2e,
      size = _ref.size,
      children = _ref.children,
      label = _ref.label,
      rotateColor = _ref.rotateColor;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(LetterAvatar, _extends({
    className: makeClass(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, classes.root, true), _defineProperty(_objectSpread2, classes.rotateColor, rotateColor), _objectSpread2), size && _defineProperty({}, classes[size], true)))
  }, e2e && {
    'data-e2e': e2e
  }), /*#__PURE__*/React.createElement(MuiTypography, _extends({
    variant: typeSizeMap[size || 'default']
  }, e2e && {
    'data-e2e': "".concat(e2e, "-label")
  }), label || children));
};

export default Avatar;

try {
  Avatar.__docgenInfo = {
    description: '',
    displayName: 'Avatar',
    methods: [],
    props: {
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      size: {
        defaultValue: null,
        description: '',
        name: 'size',
        required: false,
        type: {
          name: 'enum',
          raw: '"small" | "large"',
          value: [{
            value: '"small"'
          }, {
            value: '"large"'
          }]
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: true,
        type: {
          name: 'string'
        }
      },
      rotateColor: {
        defaultValue: null,
        description: '',
        name: 'rotateColor',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map